import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Sparkles, Clock, User, Paintbrush, Gem, Shield } from 'lucide-react';

const icons = [Sparkles, Clock, User, Paintbrush, Gem, Shield];

const WhyUsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-32 px-4 bg-secondary/30">
      <div className="max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-5xl md:text-7xl tracking-wider text-center text-foreground mb-16"
          style={{ fontFamily: 'Bebas Neue' }}
        >
          {t.whyUs.title}
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.whyUs.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="gradient-border-hover text-center p-6 rounded-sm border border-border/50 bg-card/30 backdrop-blur-sm hover:border-primary/30 hover:shadow-[0_0_25px_hsl(var(--primary)/0.1)] transition-all duration-500"
              >
                <motion.div
                  whileInView={{ rotate: [0, -10, 10, 0], scale: [1, 1.1, 1] }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 + i * 0.15, duration: 0.6 }}
                  className="inline-flex items-center justify-center w-16 h-16 rounded-sm bg-primary/10 text-primary mb-4"
                >
                  <Icon size={32} />
                </motion.div>
                <h3 className="text-2xl tracking-wider text-foreground mb-2" style={{ fontFamily: 'Bebas Neue' }}>
                  {item.title}
                </h3>
                <p className="text-muted-foreground text-sm">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
